import Page from './Page';
import Component from 'vue-class-component';

import MerchandiseCarousel from '../common/merchandise/MerchandiseCarousel.vue';
import HeaderComponent from './Header.vue';
import template from './MerchandiseCategories.vue.html';
import categories from '../../master_data/merchandise_categories.json';
import TabBar from './TabBar.vue';

export type Image = {
    merchandise_item_id: number;
    filepath: string;
};

@Component({
    template,
    components: { MerchandiseCarousel, HeaderComponent, TabBar },
})
export default class MerchandiseCategories extends Page {
    showNotice = false;
    pickedUpImagesInGeneral: Image[] = [];
    buyableMerchandiseCategories: string[] = [];

    setCategory(category: string) {
        this.app.updateQuery({ category, page: 'MerchandiseList' });
    }

    async created() {
        await this.app.fetchMerchandises();
        // チップ機能用判定
        if (this.app.enabled_gratuity && this.app.gratuity.max_amount > 0) {
            await this.app.fetchGratuities();
        }
        if (!this.app.reserve) {
            this.app.setPage('Top');
            return;
        }

        for (const merchandise of this.app.mobile_order_merchandises) {
            if (
                merchandise.merchandise_recommendation.is_general &&
                merchandise.merchandise_recommendation.valid
            ) {
                this.pickedUpImagesInGeneral.push({
                    merchandise_item_id: merchandise.id,
                    filepath: merchandise.image_urls[0],
                });
            }
        }
        for (const category of categories.map((category) => category.key)) {
            if (
                this.app.mobile_order_merchandises.find(
                    (merchandise) => merchandise.category === category
                )
            ) {
                this.buyableMerchandiseCategories.push(category);
            }
        }
    }

    setMerchandiseItem(merchandiseItemId: number) {
        this.app.updateQuery({
            page: 'MerchandiseDetail',
            merchandiseItemId,
            category: this.app.query.category,
        });
    }
}
